import React from 'react';
import { useTranslation } from 'react-i18next';
import { DataTable, Field } from '../../commons/DataTable';
import ActionsField from './ActionsField';

function CustomersExtraTable({
  data,
  total,
  offset,
  limit,
  onFilter,
  truncateTable,
  profile,
  onCustomerExtraUpdate,
  searchOffices,
}) {
  const [t] = useTranslation('IAF_INVOICES');

  return (
    <DataTable
      data={data}
      total={total}
      offset={offset}
      limit={limit}
      onFilter={onFilter}
      emptyText={t('COMMON:NO_DATA')}
    >
      <Field title="Tipo Cliente" source="type" className="text-left" />
      <Field title="Nome" source="name" className="text-left" />
      <Field title="Cognome" source="surname" className="text-left" />
      <Field
        title="Ragione Sociale"
        source="businessName"
        className="text-left"
      />
      <Field title="Telefono" source="phone" />
      <Field title="Email" source="emailReference" />
      <Field title="Partita IVA / CF" source="taxCode" />
      <Field
        title="Codice Ufficio "
        source="office.code"
        visible={profile.type === 'ASSOCIATION'}
      />
      <Field
        title="Ragione Sociale Ufficio "
        source="office.businessName"
        visible={profile.type === 'ASSOCIATION'}
      />
      <Field
        title="Referente Ufficio "
        source="office.contactPerson"
        visible={profile.type === 'ASSOCIATION'}
      />
      <Field
        title="Ufficio "
        source="office.office"
        visible={profile.type === 'ASSOCIATION'}
      />

      <Field title="N. POD" source="lightContracts.length" />
      <Field title="N. PDR" source="gasContracts.length" />

      <ActionsField
        title="Modifica gestione"
        onCustomerExtraUpdate={onCustomerExtraUpdate}
        profile={profile}
        data={data}
        truncateTable={truncateTable}
        searchOffices={searchOffices}
      />
    </DataTable>
  );
}

export default CustomersExtraTable;
